<div class="taxonomy-version-action-wrapper">
  <div class="version-block">

    <!-- lock -->
    <div class="lock-wrapper" *ngIf="taxonomyService.lockStatus">
      <div class="tooltip-container">
        <img src="../../../../assets/icons/lock.svg" alt="lock"
          matTooltip="Published versions can't be edited. Use a draft instead." matTooltipPosition="above">
      </div>
      <div class="segment-line"></div>
    </div>

    <!-- Trigger -->
    <div class="outer-wrapper">
      <div class="taxonomy-selection">
        <div class="taxonomy-header" [matMenuTriggerFor]="taxonomyMenu" #menuTrigger="matMenuTrigger">
          <!-- <div class="taxonomy">
        {{ taxoSelectedValue() }}
      </div> -->
          <div class="taxonomy">
            <ng-container *ngFor="let part of taxoSelectedParts; let last = last">
              <span [ngClass]="{
    'published-status': part.type === 'status' && part.text.toLowerCase() === 'published',
    'draft-in-review-status': part.type === 'status' && part.text.toLowerCase() === 'draft in review',
    'draft-status': part.type === 'status' && part.text.toLowerCase() === 'draft',
    'version-class': part.type === 'version' && hasStatus(),
    'no-status-class': part.type === 'version' && !hasStatus(),
    'default-class': part.type === 'default'
  }"> {{ part.text | titlecase }}
              </span>
              <span class="segment-dash" *ngIf="!last"></span>
            </ng-container>
          </div>

          <div class="taxonomy-arrow">
            <img src="../../../../assets/icons/arrow_down_grey.svg" alt="arrow-down" class="arrow-left" />
          </div>
        </div>
      </div>
    </div>

    <!-- Dropdown options -->
    <mat-menu #taxonomyMenu="matMenu" aria-label="Version History Dropdown">
      <div matMenuContent (click)="$event.stopPropagation()" class="menu-wrapper">

        <!-- Search Box -->
        <!-- <div class="search-container">
          <input matInput [(ngModel)]="searchText" placeholder="Search..." />
        </div> -->

        <!-- Dropdown Options -->
        <ng-container *ngFor="let version of filteredOptions()">
          <button mat-menu-item (click)="onSelectionChange(version); menuTrigger.closeMenu()">
            <div class="version-info">
              <div class="status-version" *ngIf="version.status || version.version">
                <span class="status" *ngIf="version.status" [ngClass]="{
                  'draft-in-review-status': version.status.toLowerCase() === 'draft' && version.DraftVisibleToAll === true,
                  'draft': version.status.toLowerCase() === 'draft' && version.DraftVisibleToAll !== true,
                  'published': version.status.toLowerCase() === 'published'
                }">
                  <ng-container *ngIf="version.status.toLowerCase() === 'draft' && version.DraftVisibleToAll === true">
                    Draft in Review
                  </ng-container>
                  <ng-container *ngIf="version.status.toLowerCase() === 'draft' && version.DraftVisibleToAll !== true">
                    {{ version.status | titlecase }}
                  </ng-container>
                  <ng-container *ngIf="version.status.toLowerCase() !== 'draft'">
                    {{ version.status | titlecase }}
                  </ng-container>
                </span>
                <span class="version-style-status" *ngIf="version.version && version.status">Version {{ version.version
                  }}</span>
                <span class="version-style-nostatus" *ngIf="version.version && version.status == ''">Version {{
                  version.version }}</span>
                <div class="segment"></div>
                <span class="timestamp"
                  *ngIf="(version.status === 'published' || (version.status === '' && version.UpdateHistory?.PublishedBy)) && version.UpdateHistory?.PublishedOn">{{version.UpdateHistory.PublishedOn
                  | utcDateTime}}</span>
                <span class="timestamp"
                  *ngIf="(version.status === 'draft' || (version.status === '' && !version.UpdateHistory?.PublishedBy)) && version.UpdateHistory?.UpdatedAt">{{version.UpdateHistory.UpdatedAt
                  | utcDateTime}}</span>
              </div>
              <div class="option-data">
                <span class="by"
                  *ngIf="version.status === 'published' || (version.status === '' && version.UpdateHistory?.PublishedBy)">by
                  {{ version.UpdateHistory?.PublishedBy }}</span>
                <span class="by"
                  *ngIf="version.status === 'draft' || (version.status === '' && !version.UpdateHistory?.PublishedBy)">by
                  {{ version.UpdateHistory?.UpdatedBy }}</span>
               </div>
            </div>
          </button>
        </ng-container>

        <!-- No Results -->
        <button mat-menu-item disabled *ngIf="filteredOptions().length === 0">
          No results found
        </button>
      </div>
    </mat-menu>

  </div>
  <div class="status-action-block">
    <div class="btn-release-for-review">
      <button [disabled]="!isReadyForRelease()" (click)="clickedOnReleaseForReview()">Release for Review</button>
    </div>
    <div class="btn-publish">
      <button [disabled]="!isReadyForPublish()" (click)="clickedOnPublish()">Publish</button>
    </div>

    <div class="btn-publish" *ngIf="!isCreateDraftDisabled()">
      <button (click)="clickedOnCreateDraft()">Create Draft</button>
    </div>
  </div>
  <div class="segment"></div>
</div>
